import { render, staticRenderFns } from "./UserProgressPage.vue?vue&type=template&id=7e65eec8"
import script from "./UserProgressPage.vue?vue&type=script&lang=js"
export * from "./UserProgressPage.vue?vue&type=script&lang=js"
import style0 from "./UserProgressPage.vue?vue&type=style&index=0&id=7e65eec8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports